/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "KD Ansari",
  title: "Hi,I'm Khusmuddin",
  subTitle:
    "A passionate Frontend Developer 🚀 having an experience of building Web with JavaScript / Reactjs / and some other cool libraries and frameworks.",
  resumeLink:
    "https://drive.google.com/file/d/1F895_Dx67HsAZJQA17eZyMkIoEMMEKDm/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/kdansari01",
  linkedin: "https://www.linkedin.com/in/khusmuddin-ansari/",
  gmail: "khusmuddin.ansari@gmail.com",
  gitlab: "/",
  facebook: "https://www.facebook.com/khusmuddin.ansari.7",
  medium: "/",
  stackoverflow: "/",
  Instagram: "https://www.instagram.com/kdansari02",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FRONTEND DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
    "⚡ Integration of third party services such as Firebase "
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },

    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "Redux",
      fontAwesomeClassname: "fab fa-react"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Sunderdeep Group of Institution",
      logo: require("./assets/images/Sunderdeep.jpg"),
      subHeader: "Bachelor of Hotel Management",
      duration: "September 2019 - April 2023"
      // desc: "Participated in the research of XXX and published 3 papers.",
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    },
    {
      schoolName: "Shambhu Dyal Inter College ",
      logo: require("./assets/images/SDI.png"),
      subHeader: "",
      duration: "September 2017 - April 2019",
      desc: "Grade A"
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "HTML", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "CSS", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "JavaScript", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "React js", //Insert stack or technology you have experience in
      progressPercentage: "75%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Bootstrap", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Front-End Developer(internship)",
      company: "UNIKORN",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "Apr 2022 – June 2022",
      desc: `Streamline all offerings with a new responsive, mobile-first approach and strategy which increased mobile traffic by 35%. A UI for the admin page has been developed to enhance the productivity of administrators, resulting in a 40% increase in business. The design streamlines administrative tasks and facilitates efficient management,providing a clear and user-friendly interface for all needs.A landing page has been designed for Unikorn to enhance brand recognition and increase traffic by 60%. The page effectively showcases the company and draws visitors, boosting online presence and increasing overall engagement.Tech Stack :- HTML, CSS, Javascript, React.js, Context Api and Firebase`
    }
    // {
    //   role: "Front-End Developer",
    //   company: "Wow Mania",
    //   companylogo: require("./assets/images/airbnbLogo.png"),
    //   desc: ""
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const myProjects = {
  title: "My Projects",
  subtitle:
    "SOME PROJECTS BUILD WITH JAVASCRIPT/REACT JS/HTML/CSS/SASS/BOOTSTRAP",
  projects: [
    {
      // image: require("./assets/video/chefSpecial.gif"),
      image: require("./assets/images/chefspcl.png"),
      projectName: "CHEF SPECIAL",
      projectDesc:
        "Desing ui using bootstrapFully Responsive for different type of devicesUsed meal db api for fetch meals and categoriesTech Stack : React.js, MealDb API",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://chef-special.netlify.app/"
        }
      ]
    },
    {
      image: require("./assets/images/blogshere.jpg"),
      projectName: "Blogs-Here",
      projectDesc:
        "This website is designed to allow users to create blogs using the React Quill editor, and it requires authentication with Firebase in order to do so. Users who are not logged in will not be able to create blogs. The website's design incorporates CSS and Bootstrap, and state management is handled using React Redux and Persist. Overall, this is a robust and professional approach to building a blog website with authentication functionality.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://blogs-here.netlify.app/"
        }
      ]
    },
    {
      // image: require("./assets/video/hungry.gif"),
      // image: require("./assets/video/hungry.mp4"),
      image: require("./assets/images/hungryman.png"),
      projectName: "Hungry",
      projectDesc:
        "admin can be upload menu or food item with thier discription, login authentication and stored on firebase ,tech stack:-react js,material ui,Tailwind,redux firebase",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://hungryman.vercel.app/"
        }
      ]
    },
    {
      // image: require("./assets/video/kdtech.gif"),
      image: require("./assets/images/kdtech.png"),
      projectName: "KDtech",
      projectDesc:
        "Desing ui using css/bootstrapFully Responsive for different type of api for fetch  and categoriesTech Stack : React.js, API",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://kdtechservice.netlify.app"
        }
      ]
    },
    {
      image: require("./assets/images/wowmania.png"),
      // image: require("./assets/video/wow Mania.gif"),
      projectName: "WOW Mania",
      projectDesc:
        "Design Login and Signup page,User can create post , delete post,Check Own Posts,Manage Gloabal State data using Redux,Create Custom Client Api Helper Function for Api fetch,Tech Stack : React.js , Redux , Firebase and Material UI",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://wow-mania.netlify.app/login"
        }
      ]
    },
    {
      // image: require("./assets/video/envited.gif"),
      image: require("./assets/images/envited.png"),
      projectName: "Envited",
      projectDesc:
        "create event for the any functions like birthday part,marriage party,etc(you can edit and make a new event their are some info.req. like event name, host name, start/end time/date etc.)",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://envitedtech.netlify.app/"
        }
      ]
    },
    {
      // image: require("./assets/video/kdmovie.gif"),
      image: require("./assets/images/Screenshot from 2022-11-16 21-26-23.png"),
      projectName: "KDmovie",
      projectDesc:
        "Advance ui ,tech stack:-react js,material ui,bootstrap,redux",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://kdmovie.vercel.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Achievements And Certifications 🏆 ",
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Coursera",
      subtitle: "certified by coursera in html/css/js developer",
      image: require("./assets/images/certif.png"),
      imageAlt: "javascript/css/html",
      footerLink: []
    },
    {
      title: "SkillUp",
      subtitle: "certified by SkillUp in React Js developer",
      image: require("./assets/images/reactjs.png"),
      imageAlt: "reactjs",
      footerLink: []
    },
    {
      title: "Cursa",
      subtitle: "certified by Cursa in Web Developer",
      image: require("./assets/images/webdev.png"),
      imageAlt: "webDev",
      footerLink: []
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const contactInfo = {
  title: "Contact Me ☎️",
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+919971765309, +916306860953",
  email_address: "khusmuddin.ansari@gmail.com , kdtechdev01@gmail.com"
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  myProjects,
  achievementSection,
  blogSection,
  contactInfo,
  isHireable
};
